exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.documentRefusedStatus[data-v-307cffee] {\r\n  color: red;\r\n  font-weight: bold;\n}\n.documentInfoFileName[data-v-307cffee] {\r\n  cursor: pointer;\n}\n@media (max-width: 992px) {\n.documentInfoAlignRight[data-v-307cffee] {\r\n    text-align: right;\n}\n.filesRow[data-v-307cffee] {\r\n    grid-column-start: 1;\r\n    grid-column-end: 3;\n}\n}\n@media (min-width: 993px) {\n.documentInfoFileName[data-v-307cffee] {\r\n    text-align: right;\n}\n.importFileButton[data-v-307cffee] {\r\n    text-align: right;\n}\n}\n.uploadedDocumentsList[data-v-307cffee] {\r\n  margin-top: 15px;\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-307cffee","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/detailPages/supplierDetailPages/DocumentGeneralInfo.vue
// module id = 1530
// module chunks = 2